import { Injectable } from '@angular/core';
import {
  DwUiConfigRegistryService,
  DwUiConfigInitDecorator,
  DwUiRegistryType,
  DwUiContainerStyleReference,
  DwUiListStyleReference,
} from '@devwareapps/devware-cap';

@Injectable()
export class AppDevwareBootstrapService {
  constructor(private uiConfigRegistyService: DwUiConfigRegistryService) {}

  @DwUiConfigInitDecorator({
    name: 'DwUiMetadataRegistrationService',
    useDI: true,
  })
  setupRegistrations() {
    this.setupContainerStyles();
    this.setupGridStyles();
    this.setupListStyles();
  }

  private setupContainerStyles() {
    this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, <DwUiContainerStyleReference>{
      keyName: '',
      display: 'App Gray',
      containerClass: 'dw-form-section-container2',
      containerInnerClass: 'dw-form-section-container-inner',
      containerTitleClass: 'dw-form-section-container-header dw-gray-bg'
    });

    /**
     * CALLOUT_WARNING is already selected in Devware admin (Assign Courses →
     * "Message - Billing" / "Message - Deferred Billing disabled") but was
     * never registered, so those sections fell back to a plain white card.
     * No containerTitleClass — the sections carry internal titles that must
     * stay hidden. Styling lives in src/styles/features/cards.scss.
     */
    this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, <DwUiContainerStyleReference>{
      keyName: 'CALLOUT_WARNING',
      display: 'Aviator — Warning Callout',
      containerClass: 'aviator-callout aviator-callout--warning',
      containerInnerClass: 'aviator-callout__body',
    });

    this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, <DwUiContainerStyleReference>{
      keyName: 'SECTION_TITLE',
      display: 'Section Title',
      containerTitleClass: 'aviator-section-header aviator-section-header--section-title'
    });

    this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, <DwUiContainerStyleReference>{
      keyName: 'PAGE_TITLE',
      display: 'Page Title',
      containerTitleClass: 'aviator-section-header aviator-section-header--page-title'
    });
  }

  private setupGridStyles() {

  }

  /**
   * Homepage redesign list styles. Each one is selectable in Devware admin
   * (UI Config → list config → "List Style") by its display name. The bodyClass
   * is the CSS hook that defines the actual layout — see
   * src/styles/features/homepage-list-styles.scss for the implementations.
   */
  private setupListStyles() {
    this.uiConfigRegistyService.registerItem(DwUiRegistryType.listStyles, <DwUiListStyleReference>{
      keyName: 'aviator-program-grid-3col',
      display: 'Aviator — Program Grid (3 columns)',
      containerClass: 'aviator-list aviator-list--program-grid',
      bodyClass: 'aviator-list__body aviator-list__body--program-grid-3col',
    });

    this.uiConfigRegistyService.registerItem(DwUiRegistryType.listStyles, <DwUiListStyleReference>{
      keyName: 'aviator-program-grid-responsive',
      display: 'Aviator — Program Grid (responsive · same card size)',
      containerClass: 'aviator-list aviator-list--program-grid',
      bodyClass: 'aviator-list__body aviator-list__body--program-grid-responsive',
    });

    this.uiConfigRegistyService.registerItem(DwUiRegistryType.listStyles, <DwUiListStyleReference>{
      keyName: 'aviator-program-list',
      display: 'Aviator — Program List (vertical)',
      containerClass: 'aviator-list aviator-list--program-list',
      bodyClass: 'aviator-list__body aviator-list__body--program-list',
    });

    this.uiConfigRegistyService.registerItem(DwUiRegistryType.listStyles, <DwUiListStyleReference>{
      keyName: 'aviator-assignment-list-compact',
      display: 'Aviator — Assignment List (compact rows)',
      containerClass: 'aviator-list aviator-list--assignment-list',
      bodyClass: 'aviator-list__body aviator-list__body--assignment-list-compact',
    });

    this.uiConfigRegistyService.registerItem(DwUiRegistryType.listStyles, <DwUiListStyleReference>{
      keyName: 'aviator-assignment-grid-2col',
      display: 'Aviator — Assignment Grid (2 columns)',
      containerClass: 'aviator-list aviator-list--assignment-grid',
      bodyClass: 'aviator-list__body aviator-list__body--assignment-grid-2col',
    });

    this.uiConfigRegistyService.registerItem(DwUiRegistryType.listStyles, <DwUiListStyleReference>{
      keyName: 'aviator-hero-feature',
      display: 'Aviator — Hero Feature (single row)',
      containerClass: 'aviator-list aviator-list--hero',
      bodyClass: 'aviator-list__body aviator-list__body--hero',
    });
  }
}
